import React from 'react';
import {observer} from 'mobx-react';

import {usePromotions} from '../../queries/promotions';

import PromotionsListScreenBase from './PromotionsListScreenBase';

// `observer()` is load-bearing even though no MobX store is read here: `usePromotions`
// reads `userStore.isLoggedIn` and `shopSelectionStore.loyaltyEnabled` at derive time
// (DIS-1567).
const PromotionsDrawnWinnersListScreen = observer(() => {
  const {drawnWinnersPromotions} = usePromotions();

  return <PromotionsListScreenBase promotions={drawnWinnersPromotions} />;
});

export default PromotionsDrawnWinnersListScreen;
